<template>
  <gallery-image v-if="images.length === 1" :image="images[0]" />
  <div v-else class="images ratio ratio-16x9 ra" ref="gallery">
    <gallery-image
      v-for="(image, index) in images"
      :key="index"
      :image="image"
    />
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.min.css';

import { ref } from 'vue';
import Viewer from 'viewerjs';

import GalleryImage from './GalleryImage';

export default {
  name: 'PostGallery',
  props: {
    images: {
      type: Array,
      requierd: true,
    },
  },
  setup() {
    const viewer = ref();
    return {
      viewer,
    };
  },
  components: {
    GalleryImage,
  },
  mounted() {
    this.viewer = new Viewer(this.$refs.gallery, {
      inline: true,
      title: false,
      rotable: false,
      scalable: false,
      rotatable: false,
      toolbar: {
        reset: false,
        prev: true,
        play: true,
        next: true,
      },
    });
  },
};
</script>

<style lang="scss">
.images {
  @media screen and (max-width: 992px) {
    --bs-aspect-ratio: calc(3 / 4 * 100%);
  }
  .gallery-image {
    max-height: 100%;
    opacity: 0;
  }
}
</style>
